module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/005_TOC#toc-listofillustrations",
      "id": "listofillustrations"
    }
  }, [_vm._v("LIST OF ILLUSTRATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "-1.8em"
    }
  }, [_vm._v("("), _c('em', [_vm._v("between pages 206 and 207")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_c('b', [_vm._v("1. Marder’s influences")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter7#ill1a",
      "id": "ill1a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William L. Langer, Harvard historian and deputy director of the CIA. "), _c('em', [_vm._v("Photo Fabian Bacharach")])])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter7#ill1b",
      "id": "ill1b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Admiral Sir Herbert Richmond. Portrait by Wilfred Gabriel de Glehn. "), _c('em', [_vm._v("By courtesy of the Masters, Fellows and Scholars of Downing College, Cambridge")])])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter7#ill1c",
      "id": "ill1c",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peter Gretton, when in command of the destroyer "), _c('em', [_vm._v("Wolverine")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter7#ill1d",
      "id": "ill1d",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peter Kemp. "), _c('em', [_vm._v("Photo Daniel Forster")])])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "margin-top": "1.1em"
    }
  }, [_c('b', [_vm._v("2. Go to the sources")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter7#ill2a",
      "id": "ill2a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussing Admiralty documents access: Vice Admiral Sir Geoffrey Barnard, Vice Admiral Sir Peter Gretton, and Marder, 1960. "), _c('em', [_vm._v("By courtesy of the Marder family")])])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter7#ill2b",
      "id": "ill2b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marder beneath the great guns of Admiral Tōgō’s "), _c('em', [_vm._v("Mikasa")]), _vm._v(", triumphant at Tsushima. "), _c('em', [_vm._v("By courtesy of the Marder family")])])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "margin-top": "1.1em"
    }
  }, [_c('b', [_vm._v("3. When naval history made news")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter7#ill3a",
      "id": "ill3a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Admiral Lord Fisher writing a fiery letter while a naval rating on fire rescue detail stands by "), _c('em', [_vm._v("By courtesy of the")]), _vm._v(" Evening Standard")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter7#ill3b",
      "id": "ill3b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marder photographed in Hyde Park on the eve of the Jutland 50th anniversary "), _c('em', [_vm._v("By courtesy of the")]), _vm._v(" Evening Standard")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter7#ill3c",
      "id": "ill3c",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marder en route to the BBC Studios reads reviews "), _c('em', [_vm._v("of his Jutland and After")]), _vm._v(", 31 May 1966. "), _c('em', [_vm._v("By courtesy of the Marder family")])])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "margin-top": "1.1em"
    }
  }, [_c('b', [_vm._v("4. Success opens doors")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter7#ill4a",
      "id": "ill4a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marder at his desk at the University of California, Irvine, 1975. "), _c('em', [_vm._v("By courtesy of the Marder family")])])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter7#ill4b",
      "id": "ill4b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("At the Admiralty 1979: First Sea Lord Admiral Sir Terence Lewin (later Baron Lewin of Greenwich) with, left, Lady Lewin and, right, Jan and Arthur Marder. "), _c('em', [_vm._v("By courtesy of the Marder family")])])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter7#ill4c",
      "id": "ill4c",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Admiral of the Fleet the Earl Mountbatten of Burma with Marder, at Broadlands, 1979. "), _c('em', [_vm._v("By courtesy of the Marder family")])])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "margin-top": "1.1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "pageviii"
    }
  }, [_c('b', [_vm._v("5. The young naval officer")])])]), _c('a', {
    attrs: {
      "id": "pageviii"
    }
  }), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('a', {
    attrs: {
      "id": "pageviii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/018_Chapter7#ill5a",
      "id": "ill5a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stephen Roskill, about 1920, in naval uniform. "), _c('em', [_vm._v("By courtesy of Nicholas Roskill")])])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter7#ill5b",
      "id": "ill5b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elizabeth and Stephen Roskill on the occasion of their wedding, 12 August 1930. The dalmatian was Elizabeth’s, the spaniel Stephens. "), _c('em', [_vm._v("By courtesy of Nicholas Roskill")])])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "margin-top": "1.1em"
    }
  }, [_c('b', [_vm._v("6. Naval command")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter7#ill6a",
      "id": "ill6a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain Stephen Roskill, RN, when in command HMNZS "), _c('em', [_vm._v("Leander. By courtesy of Nicholas Roskill")])])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter7#ill6b",
      "id": "ill6b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A pre-war view of the cruiser HMS "), _c('em', [_vm._v("Leander")]), _vm._v(", without camouflage and carrying a seaplane. She was loaned to the Royal New Zealand Navy in 1941. By "), _c('em', [_vm._v("courtesy of Nicholas Roskill")])])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "margin-top": "1.1em"
    }
  }, [_c('b', [_vm._v("7. Controversial admirals, controversial books")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter7#ill7a",
      "id": "ill7a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dustjacket of Roskill’s "), _c('em', [_vm._v("Churchill and the Admirals")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter7#ill7b",
      "id": "ill7b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dustjacket of Marder’s "), _c('em', [_vm._v("From the Dreadnought to Scapa Flow, Volume III: Jutland and After")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter7#ill7c",
      "id": "ill7c",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Admiral Sir David Beatty, when Commander-in-Chief, Grand Fleet, 1916–19. Portrait by Sir Arthur Cope. "), _c('em', [_vm._v("National Maritime Museum BHC2537")])])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter7#ill7d",
      "id": "ill7d",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Admiral of the Fleet Sir Dudley Pound. Portrait by Captain A. D. Wales-Smith. "), _c('em', [_vm._v("National Maritime Museum BHC2960")])])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "margin-top": "1.1em"
    }
  }, [_c('b', [_vm._v("8. Academic honours")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter7#ill8a",
      "id": "ill8a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Roskill brothers on the occasion of the Encaenia, and the awarding of an honorary doctorate to Stephen, 25 June 1980. Left to right: Ashton, Stephen, Oliver and Eustace. "), _c('em', [_vm._v("By courtesy of Nicholas Roskill")])])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter7#ill8b",
      "id": "ill8b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain Stephen Roskill, RN, Life Fellow of Churchill College, Cambridge. By Michael Noakes. Portrait from the Roskill Library "), _c('em', [_vm._v("By courtesy of the artist and the Master, Fellows and Scholars of Churchill College")])])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "margin-top": "1.1em"
    }
  }, [_vm._v("The English admirals are not those who built up the power of their country. If England has had Rodney, Hawke and Nelson, we have had Duquesne, Tourville and Suffren. It is that impersonal being that is called the English Admiralty; it is that which has prepared all the elements of British greatness; it is that which has known how to create homogeneous fleets, to arm them, equip them, enlist crews for them (God knows at the price of what sacrifices), and to place at their head the most capable men. Its severity has often been excessive; but, with admirals for its support.")]), _vm._v(" "), _c('p', {
    staticClass: "pararight"
  }, [_vm._v("Commander René Davelny,"), _c('br'), _c('em', [_vm._v("The Genius of Naval Warfare")]), _vm._v(" (1909).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f58dac0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Listofillustrations.vue
// module id = 72
// module chunks = 0